import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { DATASET } from '@utils/constants';
import { useFlowQueryManager, useFlowQueryStatus } from '../queryManager';

/**
 * Create a query configuration for flow data
 */
export const createQuery = (
  metricList: string[] = [],
  interval,
  granularity = 'ALL',
  filter = [] as any[][],
  options = {},
) => {
  const query = {
    type: 'timeseries',
    dataset: DATASET,
    granularity: granularity,
    options: {
      withTotals: true,
      ...(options || {}),
    },
    interval,
    filter,
    metrics: metricList,
    context: window.conviva.context,
  };

  return {
    queries: [query],
  };
};

/**
 * Hook for querying flow data with concurrency management
 */
function useFlowQuery({ flowId, queryKey, queryFn, options }) {
  const queryManager = useFlowQueryManager(flowId);
  const { queued } = useFlowQueryStatus(flowId);

  const queryRes = useQuery(queryKey, () => queryManager.exec(queryFn), {
    ...options,
  });

  const res = useMemo(
    () => ({
      ...queryRes,
      queued,
    }),
    [queryRes, queued],
  );

  // cancel any queued query on unmount
  useEffect(() => {
    return () => {
      queryManager.abort();
    };
  }, []);

  return res;
}

export default useFlowQuery;
